module.exports = __webpack_public_path__ + "static/media/lock.578bae46.png";